exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*@import '../assets/css/login.scss';*/\n.treasury-logo {\n  height: 75px;\n  width: 260px;\n  margin: 0 auto;\n}\n.treasury-logo img {\n    width: 55px;\n    height: 75px;\n}\n.treasury-logo label {\n    display: block;\n    font-size: 8pt;\n    font-weight: 600;\n    margin: 0px;\n}\n.heavy-text {\n  font-weight: 800 !important;\n}\n.heavier-text {\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c8ae859","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StartPage.vue
// module id = 675
// module chunks = 1